'use client';

import {useEffect} from 'react';

// Strip anything outside [A-Z0-9-] from the env-supplied id as a defense
// against malformed values breaking out of the script attribute.
function sanitizeId(raw: string | undefined): string {
  return (raw ?? '').replace(/[^A-Z0-9-]/gi, '');
}

function injectOnce(id: string, configure: (s: HTMLScriptElement) => void) {
  if (document.getElementById(id)) return;
  const s = document.createElement('script');
  s.id = id;
  configure(s);
  document.head.appendChild(s);
}

export default function OneTrustScripts({otId}: {otId: string}) {
  useEffect(() => {
    const safeId = sanitizeId(otId);
    if (!safeId) return;

    injectOnce('ot-autoblock', (s) => {
      s.src = `https://cdn.cookielaw.org/consent/${safeId}/OtAutoBlock.js`;
    });
    injectOnce('ot-sdk-stub', (s) => {
      s.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
      s.setAttribute('data-domain-script', safeId);
      s.setAttribute('data-document-language', 'true');
    });
    injectOnce('onetrust-wrapper', (s) => {
      s.text = 'function OptanonWrapper() {}';
    });
  }, [otId]);

  return null;
}
